// The run. A piece goes straight ahead, one square after the other, and
// stops on the last empty square before a piece of any side, a solid
// square, a deadly square, or the edge of the board. A deadly square on the
// far rank is the exception: the piece goes onto it and is removed.

import {
  fileOf,
  forwardDirection,
  isOnBoard,
  promotionRank,
  rankOf,
  squareIndex,
} from '../engine/squares';
import { isDeadly, isSolid } from '../engine/terrain';
import type { Side } from '../engine/types';
import type { GameState } from '../game/state';

/** The square where a run from `from` ends. It is `from` when the first square ahead is not open. */
export const runEnd = (state: GameState, from: number, side: Side): number => {
  const file = fileOf(from);
  const step = forwardDirection(side);
  let end = from;
  for (let rank = rankOf(from) + step; isOnBoard(file, rank); rank += step) {
    const square = squareIndex(file, rank);
    if (state.board[square] !== null || isSolid(state.rules, square)) break;
    if (isDeadly(state.rules, square)) {
      if (rank === promotionRank(side)) end = square;
      break;
    }
    end = square;
  }
  return end;
};

/** The run ends on a deadly square, so the piece is removed. */
export const isRunFatal = (state: GameState, from: number, side: Side): boolean => {
  const end = runEnd(state, from, side);
  return end !== from && isDeadly(state.rules, end);
};
